import defaultLanguage from '../../../public/phrase/en-XZ.json';

export type PhraseTranslationKeys = keyof typeof defaultLanguage;

const getMessage = (key: PhraseTranslationKeys) =>
    window?.ikea?.favourites?.text ? window.ikea.favourites.text[key] : undefined;

export default getMessage;
